export default __webpack_public_path__ + "static/img/vogue_scene_animated_0365.486d75e.webp";